var footnote = function() {
  const $stage = $(".stage");
  const $footNoteTop = $stage.find(".stage__footnote .richtext[data-footnote='short']");
  const $footNoteTopLabel = $footNoteTop.find("label");
  const $footNoteBottom = $stage.find(".stage__footnote .richtext[data-footnote='long']");

  const $footNoteTopLinks = $footNoteTop.find("a");
  // Add aria-expanded false to links
  $footNoteTopLabel.attr("aria-expanded", false);
  const $footNoteBottomID = $footNoteTopLinks.closest(".richtext").siblings(".richtext").attr("id");
  // Add aria-controls to links
  $footNoteTopLabel.attr("aria-controls", $footNoteBottomID);

  // Removes href attribute, if present, from a-tags because the surrounding label is already focusable
  $footNoteTopLinks.filter(function() {
    var href = $(this).attr("href");
    return typeof href != "undefined" && href != false;
  }).attr("tabindex", -1);

  function hasInteracted(event) {
    if (event.type === "click") {
      return true;
    } else if (event.type === "keypress") {
      var code = event.charCode || event.keyCode;
      if ((code === 32) || (code === 13)) {
        return true;
      }
    } else {
      return false;
    }
  }

  // FootNote Top
  $footNoteTopLabel.on("click keypress", function(e) {

    if (!hasInteracted(e)) {
      return;
    }

    e.preventDefault();

    var $this = $(this);
    var $sibling = $this.closest(".richtext").siblings(".richtext");

    if ($sibling.attr("aria-hidden") === "true") {
      $sibling
        .slideUp(300)
        .attr("aria-hidden", false);
    } else {
      $sibling
        .slideDown(300)
        .attr("aria-hidden", true);
      $this.attr("aria-expanded", false);
    }

    $sibling.slideToggle(300);
    e.preventDefault();
  });

  // FootNote Bottom
  $footNoteBottom.on("click", function(e) {
    var $this = $(this);
    var $sibling = $this.closest(".richtext").siblings(".richtext").find("label");

    if ($sibling.attr("aria-expanded") === "true") {
      $sibling.attr("aria-expanded", false);
    }
    $this
      .slideToggle()
      .attr("aria-hidden", true);
    e.preventDefault();
  });
};
// eslint-disable-next-line
export { footnote };